import ComboStateService from './services/comboStateService.js';

const moduleName = 'comboState';

angular
    .module(moduleName, [])
    .service('comboStateService', ComboStateService);

export default moduleName;
